export const PROGRESS_METRIC = {
  pain: 'pain',
  mobility: 'mobility',
  walking: 'walking',
  stairs: 'stairs',
  gettingUp: 'getting_up',
  muscleStrength: 'muscle_strength',
  endurance: 'endurance',
  mood: 'mood',
  weight: 'weight',
} as const;

export type ProgressMetricCode = (typeof PROGRESS_METRIC)[keyof typeof PROGRESS_METRIC];

export const RATING_METRIC_MINIMUM_VALUE = 0;
export const RATING_METRIC_MAXIMUM_VALUE = 10;
export const WEIGHT_METRIC_MINIMUM_VALUE = 0;

interface WritableProgressMetricDefinition {
  code: ProgressMetricCode;
  minimumValue: number;
  maximumValue: number | null;
  unitCode: string | null;
}

export const WRITABLE_PROGRESS_METRICS: WritableProgressMetricDefinition[] = [
  {
    code: PROGRESS_METRIC.mobility,
    minimumValue: RATING_METRIC_MINIMUM_VALUE,
    maximumValue: RATING_METRIC_MAXIMUM_VALUE,
    unitCode: null,
  },
  {
    code: PROGRESS_METRIC.walking,
    minimumValue: RATING_METRIC_MINIMUM_VALUE,
    maximumValue: RATING_METRIC_MAXIMUM_VALUE,
    unitCode: null,
  },
  {
    code: PROGRESS_METRIC.stairs,
    minimumValue: RATING_METRIC_MINIMUM_VALUE,
    maximumValue: RATING_METRIC_MAXIMUM_VALUE,
    unitCode: null,
  },
  {
    code: PROGRESS_METRIC.gettingUp,
    minimumValue: RATING_METRIC_MINIMUM_VALUE,
    maximumValue: RATING_METRIC_MAXIMUM_VALUE,
    unitCode: null,
  },
  {
    code: PROGRESS_METRIC.muscleStrength,
    minimumValue: RATING_METRIC_MINIMUM_VALUE,
    maximumValue: RATING_METRIC_MAXIMUM_VALUE,
    unitCode: null,
  },
  {
    code: PROGRESS_METRIC.endurance,
    minimumValue: RATING_METRIC_MINIMUM_VALUE,
    maximumValue: RATING_METRIC_MAXIMUM_VALUE,
    unitCode: null,
  },
  {
    code: PROGRESS_METRIC.mood,
    minimumValue: RATING_METRIC_MINIMUM_VALUE,
    maximumValue: RATING_METRIC_MAXIMUM_VALUE,
    unitCode: null,
  },
  {
    code: PROGRESS_METRIC.weight,
    minimumValue: WEIGHT_METRIC_MINIMUM_VALUE,
    maximumValue: null,
    unitCode: 'kg',
  },
];

export const PROGRESS_COMPARISON_CLASSIFICATION = {
  improved: 'improved',
  worsened: 'worsened',
  unchanged: 'unchanged',
  insufficient: 'insufficient',
} as const;
